import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { API_BASE } from '../services/config';

export interface SeoData {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImageUrl?: string;
  twitterCard?: string;
  noindex?: boolean;
  schemaJson?: unknown;
}

export function useSeo(): SeoData | null {
  const { pathname } = useLocation();
  const params = useParams();
  const localeParam = (params as Record<string, string | undefined>).locale;
  const rawLocale = (localeParam || 'et').toLowerCase();
  const normalizedLocale = rawLocale === 'uk' ? 'ua' : rawLocale;
  const locale = ['et', 'en', 'ru', 'ua'].includes(normalizedLocale)
    ? normalizedLocale
    : 'et';
  const [seo, setSeo] = useState<SeoData | null>(null);

  useEffect(() => {
    let cancelled = false;
    const fetchSeo = async () => {
      try {
        const url = `${API_BASE}/api/public/seo?path=${encodeURIComponent(pathname)}&locale=${encodeURIComponent(locale)}`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const data = (await res.json()) as SeoData;
        if (!cancelled) setSeo(data);
      } catch {
        // ignore
      }
    };
    void fetchSeo();
    return () => {
      cancelled = true;
    };
  }, [pathname, locale]);

  return seo;
}
